export const StoreState = {
    results:'results',
    page: 'page'
}

export const state = {
    [StoreState.results]:[],
    [StoreState.page]: 0
}
